import { api } from "../api";

const findAllVehicleAlerts = async (
    token: string,
    customerId: number,
    departmentId?: number
) => {
    return api.get(`/vehicle-alerts/customer/${customerId}`, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
        params: departmentId && departmentId > -1 ? { departmentId } : undefined,
    });
};

export default findAllVehicleAlerts;
